import React from "react";
import LandingDesktop from "./LandingDesktop";
import LandingMobile from "./LandingMobile";
import { useMediaQuery, useTheme } from "@mui/material";

const Landing = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // md and above

  return <>{isDesktop ? <LandingDesktop /> : <LandingMobile />}</>;
};

export default Landing;
